window.addEventListener('load', function() {
  document.querySelectorAll('slider-component').forEach(function(slider) {
    if (slider.classList.contains('thumbnail-slider')) return;
    
    var links = slider.querySelectorAll('.slider-counter__link');
    var next = slider.querySelector('button[name="next"]');

    if (links.length >= 2) {
      var current = 0;
      setInterval(function() {
        current = (current + 1) % links.length;
        links[current].click();
      }, 5000);
    } else if (next) {
      setInterval(function() {
        if (!next.disabled) {
          next.click();
        } else {
          var prev = slider.querySelector('button[name="previous"]');
          while (prev && !prev.disabled) prev.click();
        }
      }, 5000);
    }
  });
});